import parsePhoneNumber from 'libphonenumber-js';

const NANP_NATIONAL_LENGTH = 10;
const NANP_COUNTRY_CODE = '1';

// Imported numbers often carry the US country code without a leading `+`,
// so strip it before the NANP layout below drops the trailing digit.
function toNationalDigits(phoneNumber: string): string {
  const digits = phoneNumber.replace(/\D/g, '');
  return digits.length === NANP_NATIONAL_LENGTH + 1 && digits.startsWith(NANP_COUNTRY_CODE) ? digits.slice(1) : digits;
}

export function formatPhoneNumber(phoneNumber: string) {
  // Handle phone extensions (separated by ; or ,)
  const extensionRegex = /^([^;,]+)[;,](.+)$/;
  const extensionMatch = extensionRegex.exec(phoneNumber);
  const baseNumber = extensionMatch?.[1] ?? phoneNumber;
  const extension = extensionMatch?.[2] ?? null;

  let formattedBase: string;

  if (isValidE164Format(baseNumber)) {
    formattedBase = parsePhoneNumber(baseNumber)?.formatNational() || baseNumber;
  } else {
    const fullNumber = toNationalDigits(baseNumber);
    if (fullNumber.length === 0) {
      formattedBase = fullNumber;
    } else if (fullNumber.length < 4) {
      formattedBase = fullNumber;
    } else if (fullNumber.length < 7) {
      formattedBase = `(${fullNumber.slice(0, 3)}) ${fullNumber.slice(3)}`;
    } else if (fullNumber.length === 7) {
      formattedBase = `${fullNumber.slice(0, 3)}-${fullNumber.slice(3)}`;
    } else if (fullNumber.length <= NANP_NATIONAL_LENGTH) {
      formattedBase = `(${fullNumber.slice(0, 3)}) ${fullNumber.slice(3, 6)}-${fullNumber.slice(6)}`;
    } else {
      formattedBase = baseNumber;
    }
  }

  if (extension) {
    // Sanitize extension to only allow digits
    const sanitizedExtension = extension.replace(/\D/g, '');
    if (sanitizedExtension) {
      return `${formattedBase} ext. ${sanitizedExtension}`;
    }
  }
  return formattedBase;
}

function isValidE164Format(phoneNumber: string) {
  const regex = /^\+[1-9]\d{10,14}$/;
  return regex.test(phoneNumber);
}

export function toTitleCase(str: string) {
  if (str.length === 0) return str;
  return `${str.charAt(0).toUpperCase()}${str.slice(1).toLowerCase()}`;
}

export function snakeCaseToTitleCase(str: string) {
  return str.split('_').map(toTitleCase).join(' ');
}

export function toNumberWithCommas(num: number | string): string {
  const cleanedInput = num.toString().replace(/\D/g, '');
  // Format number with commas
  return cleanedInput.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
